const qs = require('querystring');
import API from './index';

export function getMySubCustomerList() {
  return API.get('/customer/QuerySubCustomerList').then(res => res.data);
}

export function addPackage({ name, deliveryNo, remarks, declarePrice }) {
  // goods-name=包包&delivery-no=SF23302214558&pacakge-remark=
  return API.post(
    '/package/AddPackage',
    qs.stringify({
      'goods-name': name,
      'delivery-no': deliveryNo,
      'pacakge-remark': remarks,
      'declare-price': declarePrice,
    })
  ).then(res => res.data);
}
